export class Scan {

    articleRef: string;
    barcode: string;
    numberOfItems: number;

    constructor(){}

}


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/orders/scan.ts